<template>
  <adv-input-spinner
    :min="productCodeData.productStock > 0 ? 1 : 0"
    :max="maxAmount"
    :quantity="localQuantity"
    :button-css="buttonCss"
    :unavailable="!this.productCodeId || productCodeData.productStock <= 0"
    v-on:quantity-changed="quantityChanged"></adv-input-spinner>
</template>

<script>
import AdvInputSpinner from './presentation/AdvInputSpinner'
import productMixin from './mixins/productMixins'
import store from '../../vue/store'

export default {
  name: 'AdvProductInputSpinner',
  props: {
    productCodeId: {
      type: Number
    },
    unavailable: {
      type: Boolean
    },
    quantity: {
      type: Number
    },
    maxAmount: {
      type: Number
    },
    buttonCss: {
      type: String
    },
    watchForProductCodeIdChanges: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    AdvInputSpinner
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.1',
      localQuantity: 0
    }
  },
  mounted () {
    this.localQuantity = this.quantity
  },
  watch: {
    productCodeId (val) {
      if (!this.watchForProductCodeIdChanges) {
        return
      }
      this.localQuantity = this.productCodeData.productStock > 0 ? store.getters.cartProductCodeQuantity(val) : 0
    },
    quantity (val) {
      this.localQuantity = val
    }
  },
  methods: {
    quantityChanged (quantity) {
      this.localQuantity = quantity
      this.$emit('quantity-changed', quantity)
    }
  }
}
</script>
